import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import { SupportedCurrency } from '@core/models';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.currencies}`;

  getSupportedCurrencies(): Observable<SupportedCurrency[]> {
    return this.http.get<SupportedCurrency[]>(this.baseUrl);
  }
}
